import React, { useState } from "react";
import style from "./CatCard.module.css";

export const CatCard = ({ img, nombre, codigo }) => {
  return (
    <div className={style.conteiner}>
      <a
        className={style.link}
        href={
          Array.isArray(img) ? `/detail/${codigo}/0` : `/detail/${codigo}/7`
        }
      >
        <img
          className={style.img}
          src={Array.isArray(img) ? img[0] : img}
          alt="prodImg"
        />
        <div>
          <h3 className={style.name}>{nombre}</h3>

          <div className={style.codeCont}>
            <p className={style.textCode}>Codigo</p>
            <p className={style.code}>{codigo}</p>
          </div>
        </div>
      </a>
    </div>
  );
};
